module.exports = __webpack_public_path__ + "img/university_19.384caec7.png";